/**
 * React application router
 * PURPOSE: Connects public pages, account pages, admin pages and route analytics.
 *
 * EDITING GUIDE:
 * - Read the comments above each section or function before changing behavior.
 * - Keep validation, authentication and error handling in place for production safety.
 * - Search for "EDIT HERE" to find the most common business-content settings.
 */

import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import AdminDashboard from './pages/AdminDashboard';
import PropertyDetails from './pages/PropertyDetails';
import UserDashboard from './pages/UserDashboard';
import { trackEvent } from './analytics';
import { LanguageProvider } from './i18n';
import './App.css';

/**
 * Track public route changes without rendering visible interface elements.
 */
function PublicRouteAnalytics() {
  const location = useLocation();

  useEffect(() => {
    // EDIT HERE: add paths here when a private area should not be counted as public visitor traffic.
    if (location.pathname.startsWith('/admin')) return;

    const entryKey = 'capital-entry-tracked';
    if (!sessionStorage.getItem(entryKey)) {
      sessionStorage.setItem(entryKey, '1');
      trackEvent('site_enter');
    }
    trackEvent('page_view');
  }, [location.pathname, location.search]);

  return null;
}

/**
 * Declare the client-side routes for public, user and administrator pages.
 */
function App() {
  return (
    <LanguageProvider>
      <Router>
        <PublicRouteAnalytics />
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/account" element={<UserDashboard />} />
            <Route path="/property/:id" element={<PropertyDetails />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
